import { render, staticRenderFns } from "./SelectSearchUsers.vue?vue&type=template&id=54b2277f"
import script from "./SelectSearchUsers.vue?vue&type=script&lang=ts"
export * from "./SelectSearchUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports